// extracted by mini-css-extract-plugin
export default {"formContent":"style_formContent__yipeH","breadCont":"style_breadCont__Vvi0X","container":"style_container__Kqf98"};